import React, { useState, useCallback, useRef, useEffect } from 'react';
import Map from './Map';
import RankingPanel from './RankingPanel';
import ResortDetail from './ResortDetail';
import { LngLatBounds } from 'mapbox-gl';
import './RankingMap.css';

const RankingMap = () => {
  const [selectedResort, setSelectedResort] = useState(null);
  const [markers, setMarkers] = useState([]);
  const mapRef = useRef(null);

  // 处理标记更新
  const handleMarkersUpdate = useCallback((newMarkers) => {
    setMarkers(newMarkers);
  }, []);

  // 处理关闭详情页
  const handleCloseDetail = useCallback(() => {
    setSelectedResort(null);
  }, []);

  // 仅在初始加载标记时调整地图视角，而不是每次选择滑雪场时
  useEffect(() => {
    if (markers.length > 0 && mapRef.current?.getMap() && !selectedResort) {
      const map = mapRef.current.getMap();
      
      // 计算所有标记点的边界
      const bounds = new LngLatBounds();
      
      markers.forEach(marker => {
        bounds.extend([marker.longitude, marker.latitude]);
      });

      // 调整地图视角以显示所有标记点
      map.fitBounds(bounds, {
        padding: { top: 50, bottom: 50, left: 50, right: 50 },
        maxZoom: 16,
        duration: 1000
      });
    }
  }, [markers]); // 移除 selectedResort 依赖

  return (
    <div className="ranking-map-container">
      <div className="map-container">
        <Map
          ref={mapRef}
          markers={markers}
          selectedResort={selectedResort}
          onResortSelect={setSelectedResort}
          type="ranking"
        />
      </div>
      <div className="ranking-panel">
        <RankingPanel
          onMarkersUpdate={handleMarkersUpdate}
          selectedResort={selectedResort}
          onResortSelect={setSelectedResort}
        />
      </div>
      {selectedResort && (
        <div className="resort-detail-overlay">
          <ResortDetail 
            resort={selectedResort} 
            onClose={handleCloseDetail}
          />
        </div>
      )}
    </div>
  );
};

export default RankingMap; 